module.exports = __webpack_public_path__ + "static/media/twitter.69f95744.svg";